/**
 * Centralized configuration for hardcoded environment variables.
 * These values can be overridden by environment variables at build time.
 * This approach allows flexibility for CI/CD deployment while supporting local development.
 */

const CONFIG = {
  SMARTY_EMBEDDED_KEY: process.env.REACT_APP_SMARTY_EMBEDDED_KEY || "257914479359645124",
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || process.env.REACT_APP_STRIPE_PUB_KEY || "pk_test_51S5WzjHTggE8vkF4wEPAO9fR9lBBUxWRDI7AJWvrYNMRKMD24SG82x2WWEEDX27XYFngUXWh55Jy5xniCd0SjOwW00xyBunNPz",
  IFRAME_ORIGIN: process.env.REACT_APP_IFRAME_ORIGIN || "https://stagingadminapi.welliemd.com/api/v1",
  ENABLE_IFRAME_MODE: process.env.REACT_APP_ENABLE_IFRAME_MODE === 'true' || true,
  ENABLE_COMPONENT_MODE: process.env.REACT_APP_ENABLE_COMPONENT_MODE === 'true' || true,
};

export default CONFIG;
